var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchasedTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006838",
    d: "M81.25,105.31a8,8,0,1,0-5.8-2.34A7.87,7.87,0,0,0,81.25,105.31Zm0-32.56a8,8,0,1,0-5.8-2.34A7.87,7.87,0,0,0,81.25,72.75Zm0-32.56a8,8,0,0,0,8.14-8.14,8.14,8.14,0,1,0-16.28,0,8,8,0,0,0,8.14,8.14ZM146.7,130H16.3a15.72,15.72,0,0,1-11.51-4.77A15.65,15.65,0,0,1,0,113.75V81.25a15.72,15.72,0,0,0,11.51-4.77,16.15,16.15,0,0,0,0-23A15.72,15.72,0,0,0,0,48.75V16.25A15.65,15.65,0,0,1,4.79,4.77,15.72,15.72,0,0,1,16.3,0H146.7a15.72,15.72,0,0,1,11.51,4.77A15.65,15.65,0,0,1,163,16.25v32.5A16.32,16.32,0,0,0,146.7,65,16.32,16.32,0,0,0,163,81.25v32.5A16.32,16.32,0,0,1,146.7,130Zm-.7-16V93.18a33.42,33.42,0,0,1-11.88-12,32.32,32.32,0,0,1,0-32.46A33.32,33.32,0,0,1,146,36.83V16H16V36.83A33.32,33.32,0,0,1,27.88,48.77a32.32,32.32,0,0,1,0,32.46A33.42,33.42,0,0,1,16,93.18V114Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasedTicket);
export default __webpack_public_path__ + "static/media/purchasedTicket.f12ebfdc413057b2aa2c516c9530a8cf.svg";
export { ForwardRef as ReactComponent };